module.exports = __webpack_public_path__ + "img/water.be5030ca.webp";